export function updateAction(attrs) {
  return {
    type: 'UPDATE_ATTRIBUTE',
    ...attrs,
  };
}
